import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Form } from 'react-final-form';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import { Button, Input, Alert } from 'reactstrap';
import KeyIcon from 'mdi-react/KeyIcon';
import { useAuth } from '../../../contexts/AuthContext';

const SignupForm = ({ onSubmit, loading, error }) => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { signInWithGoogle } = useAuth();

  const handleGoogleSignIn = async () => {
    await signInWithGoogle();
  };

  return (
    <Form onSubmit={() => onSubmit(fullName, email, password)}>
      {({ handleSubmit }) => (
        <form className="form" onSubmit={handleSubmit}>
          {error && (
            <Alert color="danger" className="mb-3">
              {error}
            </Alert>
          )}
          <div className="form__form-group">
            <span className="form__form-group-label">Your Name</span>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <AccountOutlineIcon />
              </div>
              <Input
                name="fullName"
                value={fullName}
                onChange={e => setFullName(e.target.value)}
                type="text"
                placeholder="Marie Curie"
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Work Email</span>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <AccountOutlineIcon />
              </div>
              <Input
                name="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                type="email"
                placeholder="marie@curie.labs"
                required
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Password</span>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <KeyIcon />
              </div>
              <Input
                name="password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Password"
              />
            </div>
          </div>
          <Button 
            className="btn btn-primary account__btn account__btn--small" 
            type="submit"
            disabled={loading}
          >
            {loading ? 'Signing Up...' : 'Sign Up'}
          </Button>
          <Button 
            className="btn btn-outline-primary account__btn account__btn--small" 
            onClick={handleGoogleSignIn}
            type="button"
            disabled={loading}
          >
            Sign Up with Google
          </Button>
          <NavLink to="/login" className="btn btn-outline-secondary account__btn account__btn--small">
            Already have an account? Sign In
          </NavLink>
        </form>
        )}
    </Form>
  );
};

SignupForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

SignupForm.defaultProps = {
  loading: false,
  error: null,
};

export default SignupForm;
